/* PERF:BEGIN — LCP LOGGER */
(function(){
  try{
    if('PerformanceObserver'in window){
      const po=new PerformanceObserver((list)=>{
        const e=list.getEntries().find(x=>x.name==='largest-contentful-paint');
        if(e) console.info('[PERF] LCP:', Math.round(e.startTime),'ms');
      });
      po.observe({type:'largest-contentful-paint', buffered:true});
    }
  }catch(e){}
})();
/* PERF:END — LCP LOGGER */
